<template>
  <div id="mainNavbar">
    <div class="mainNavBar">
      <ul>
        <li
          :class="[
            { active: checkActiveMenu(menu.link) },
            { lockMenu: (menu.lock && menu.lock.value) || menu.canNotAccess },
          ]"
          v-for="(menu, index) in listMenu"
          :key="index"
        >
          <router-link
            v-if="!(menu.lock && menu.lock.value) && !menu.canNotAccess"
            :to="{ name: menu.link !== undefined ? menu.link.name : '', query: SetQueryURL(menu) }"
          >
            <div>
              <span v-if="menu.icon" :class="menu.icon"></span>
              <img v-else width="15px" style="margin-top: -8px" :src="menu.img" alt="" />
              {{ $t(menu.name) }}
              <img v-if="menu.showNewIcon" src="@/assets/img/Badge_new.png" class="imgNewFeature" />
            </div>
          </router-link>

          <div v-if="menu.lock && menu.lock.value">
            <div class="lockIsMenu">
              <div>
                <i class="fas fa-tools"></i>
                <p>{{ $t(menu.lock.text) }}</p>
                <img v-if="menu.showNewIcon" src="@/assets/img/Badge_new.png" class="imgNewFeature" />
              </div>
            </div>
            <span :class="menu.icon"></span>
            {{ $t(menu.name) }}
          </div>

          <div v-if="menu.canNotAccess && !(menu.lock && menu.lock.value)">
            <div class="lockIsMenu">
              <div>
                <i class="icon-lock_user_right"></i>
                <p>{{ $t("Limited_User_rights") }}</p>
              </div>
            </div>
            <span :class="menu.icon"></span>
            {{ $t(menu.name) }}
          </div>

          <div
            v-if="menu.dropdown && !(menu.lock && menu.lock.value) && !menu.canNotAccess"
            v-show="!hideDropdown"
            :class="['dropdown', menu.class]"
          >
            <div
              name="selectDropdown"
              v-for="select in menu.dropdown"
              v-show="!select.hide"
              :key="select.key"
              :class="{ lockOrCanNotAccessSelectDropdown: (select.lock && select.lock.value) || select.canNotAccess }"
            >
              <router-link
                v-if="!(select.lock && select.lock.value) && !select.canNotAccess"
                :to="{
                  name: select.link !== undefined ? select.link.name : '',
                  query: SetQueryURL(select),
                }"
              >
                <div :class="'selectDropdown ' + select.bg" @click="hide()">
                  <div>
                    <i :class="select.icon"></i>
                    <a class="nameSelect">{{ $t(select.name) }} </a>
                  </div>

                  <i v-if="select.option" class="fa fa-chevron-right"></i>
                </div>
              </router-link>

              <div v-if="select.lock && select.lock.value" :class="'selectDropdown'">
                <div class="lockOrCanNotAccessSelect">
                  <i class="fas fa-lock"></i>
                  <p>{{ $t(select.lock.text) }}</p>
                </div>
                <div>
                  <i class="fas fa-lock"></i>
                  <a class="nameSelect">{{ $t(select.name) }}</a>
                  <img v-if="select.showNewIcon" src="@/assets/img/Badge_new.png" class="imgNewFeature" />
                </div>

                <i v-if="select.option" class="fa fa-chevron-right"></i>
              </div>

              <div v-if="select.canNotAccess && !(select.lock && select.lock.value)" :class="'selectDropdown'">
                <div class="lockOrCanNotAccessSelect">
                  <i class="icon-lock_user_right"></i>
                  <p>{{ $t("Limited_User_rights") }}</p>
                </div>
                <div>
                  <i class="icon-lock_user_right"></i>
                  <a class="nameSelect">{{ $t(select.name) }}</a>
                  <img v-if="select.showNewIcon" src="@/assets/img/Badge_new.png" class="imgNewFeature" />
                </div>

                <i v-if="select.option" class="fa fa-chevron-right"></i>
              </div>

              <div v-if="!(select.lock && select.lock.value) && !select.canNotAccess" :class="'option ' + select.class">
                <div
                  v-for="option in select.option"
                  :key="option.key"
                  :class="{
                    lockOrCanNotAccessOptionDropdown: (option.lock && option.lock.value) || option.canNotAccess,
                  }"
                >
                  <router-link
                    v-if="!(option.lock && option.lock.value) && !option.canNotAccess"
                    :to="{
                      name: option.link !== undefined ? option.link.name : '',
                      query: SetQueryURL(option),
                    }"
                  >
                    <div :class="'optionDropdown ' + option.bg" @click="hide()">
                      <i :class="option.icon"></i>
                      <a class="nameOption">{{ $t(option.name) }} </a>
                      <img v-if="option.showNewIcon" src="@/assets/img/Badge_new.png" class="imgNewFeature" />
                    </div>
                  </router-link>

                  <div v-if="option.lock && option.lock.value" :class="['optionDropdown']">
                    <div class="lockOrCanNotAccessOption">
                      <i class="fas fa-lock"></i>
                      <p>{{ $t(option.lock.text) }}</p>
                    </div>
                    <div :class="['d-flex align-items-start justify-content-center']">
                      <i class="fas fa-lock mr-2"></i>
                      <p class="nameSelect">{{ $t(option.name) }}</p>
                    </div>

                    <i v-if="option.option" class="fa fa-chevron-right"></i>
                  </div>

                  <div v-if="option.canNotAccess && !(option.lock && option.lock.value)" :class="['optionDropdown']">
                    <div class="lockOrCanNotAccessOption">
                      <i class="icon-lock_user_right"></i>
                      <p>{{ $t("Limited_User_rights") }}</p>
                    </div>
                    <div :class="['d-flex align-items-start justify-content-center']">
                      <i class="icon-lock_user_right mr-2"></i>
                      <p class="nameSelect">{{ $t(option.name) }}</p>
                    </div>

                    <i v-if="option.option" class="fa fa-chevron-right"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import {
  Package,
  ParamsReloadType,
  PndType,
  PP30FormTableViewStatusType,
  RouterAction,
  TransactionTableViewStatusType,
  WhtCertificateTableViewStatusType,
} from "@/enums/enums";
import { CheckMerchantAFPPackage, CheckMerchantPackage, CheckMerchantTrial, MerchantId } from "@/helper/userHelper";

import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StoreSetting = namespace("Setting");

@Component
export default class MainNavbar extends Vue {
  private listMenu: Array<any> = [];
  private hideDropdown = false;
  private isConnectWithPeak = false;
  private callCheckMerchantPackage = CheckMerchantPackage([Package.Free, Package.AFPFree]);
  private isMerchantPackageAFP = CheckMerchantAFPPackage();
  private isPackageTrial = CheckMerchantTrial();

  @StoreSetting.Getter
  private getSettingConnectPeakModel!: any;

  created() {
    if (this.getSettingConnectPeakModel) {
      this.isConnectWithPeak = this.getSettingConnectPeakModel.isPeakTaxConnected;
    }
    this.listMenu = this.SetListMenu();
  }

  public SetListMenu() {
    let isLock = false;
    let lockText = "";
    if (!this.isConnectWithPeak) {
      isLock = true;
      lockText = "Connect_Peak";
    } else if (this.callCheckMerchantPackage) {
      isLock = true;
      if (this.isMerchantPackageAFP) {
        lockText = "Package_Accountant";
      } else {
        lockText = "Package_Pro_Plus";
      }
    }
    const listMenu = [
      {
        name: "Menu_Home",
        icon: "",
        img: require("@/assets/img/menubar/home.png"),
        link: { name: "home" },
      },
      {
        name: "Header_WithHoldingTax",
        icon: "",
        img: require("@/assets/img/menubar/wallet.png"),
        link: { name: "withholding" },
        canNotAccess: !this.$can("access", "Wht_Menu"),
        dropdown: [
          {
            name: "Withholding_Tax",
            link: { name: "withholding" },
            canNotAccess: !this.$can("access", "WhtCertificate_Menu"),
            option: [
              {
                name: "Btn_CreateWHT",
                bg: "bgOption",
                link: { name: "withholding", at: RouterAction.Create },
                canNotAccess: !this.$can("create", "Wht_Create"),
              },
              {
                name: "FetchData",
                bg: "blueDefault",
                icon: "fas fa-sync-alt",
                link: { name: "withholding", at: RouterAction.FetchData },
                lock: { value: isLock && !this.isPackageTrial, text: "Package_Basic" },
                canNotAccess: !this.$can("create", "Wht_Create"),
              },
              {
                name: "Table_Tap_AwaitFiling",
                link: { name: "withholding", stid: WhtCertificateTableViewStatusType.AwaitFiling },
              },
              {
                name: "Table_Tap_FiledTax",
                link: { name: "withholding", stid: WhtCertificateTableViewStatusType.FiledTax },
              },
              { name: "Menu_Overview", link: { name: "withholding", stid: WhtCertificateTableViewStatusType.All } },
            ],
          },
          {
            name: "PND_1_Form",
            link: { name: "pnd1", epti: PndType.PND1 },
            canNotAccess: !this.$can("access", "Pnd1_Menu"),
            option: [
              {
                name: "PND_1_Form_Create",
                bg: "bgOption",
                link: { name: "pnd1Create", epti: PndType.PND1, date: new Date() },
                canNotAccess: !this.$can("create", "Pnd1_Create"),
              },
              { name: "Menu_Overview", link: { name: "pnd1", epti: PndType.PND1 } },
            ],
          },
          {
            name: "PND_2_Form",
            link: { name: "pnd2", epti: PndType.PND2 },
            canNotAccess: !this.$can("access", "Pnd2_Menu"),
            option: [
              {
                name: "PND_2_Form_Create",
                bg: "bgOption",
                link: { name: "pnd2Create", epti: PndType.PND2, date: new Date() },
                canNotAccess: !this.$can("create", "Pnd2_Create"),
              },
              { name: "Menu_Overview", link: { name: "pnd2", epti: PndType.PND2 } },
            ],
          },
          {
            name: "PND_3_Form",
            link: { name: "pnd3", epti: PndType.PND3 },
            canNotAccess: !this.$can("access", "Pnd3_Menu"),
            option: [
              {
                name: "PND_3_Form_Create",
                bg: "bgOption",
                link: { name: "pnd3Create", epti: PndType.PND3, date: new Date() },
                canNotAccess: !this.$can("create", "Pnd3_Create"),
              },
              { name: "Menu_Overview", link: { name: "pnd3", epti: PndType.PND3 } },
            ],
          },
          {
            name: "PND_53_Form",
            link: { name: "pnd53", epti: PndType.PND53 },
            canNotAccess: !this.$can("access", "Pnd53_Menu"),
            option: [
              {
                name: "PND_53_Form_Create",
                bg: "bgOption",
                link: { name: "pnd53Create", epti: PndType.PND53, date: new Date() },
                canNotAccess: !this.$can("create", "Pnd53_Create"),
              },
              { name: "Menu_Overview", link: { name: "pnd53", epti: PndType.PND53 } },
            ],
          },
          {
            name: "PND_54_Form",
            link: { name: "" },
            lock: { value: true, text: "Lock_HeaderMenu" },
            hide: true,
            option: [
              { name: "PND_54_Form_Create", bg: "bgOption", link: { name: "" } },
              { name: "Table_Tap_AwaitFiling", link: { name: "" } },
              { name: "Table_Tap_FiledTax", link: { name: "" } },
              { name: "Menu_Overview", link: { name: "" } },
            ],
          },
          {
            name: "Import_Document",
            link: { name: "" },
            lock: { value: true, text: "Lock_HeaderMenu" },
            hide: true,
          },
        ],
      },
      {
        name: "VAT",
        icon: "",
        img: require("@/assets/img/menubar/document.png"),
        link: { name: "salesVATItem" },
        canNotAccess:
          !this.$can("access", "View_SalesTaxInvoice") &&
          !this.$can("access", "View_PurchaseTaxInvoice") &&
          !this.$can("access", "View_PP30"),
        dropdown: [
          {
            name: "Sales_Tax_Item",
            link: { name: "salesVATItem", stid: TransactionTableViewStatusType.All },
            canNotAccess: !this.$can("access", "View_SalesTaxInvoice"),
            option: [
              {
                name: "Create_Sales_Tax_Item",
                bg: "bgOption",
                link: { name: "salesVATItem", at: RouterAction.Create, stid: TransactionTableViewStatusType.All },
                canNotAccess: !this.$can("create", "Create_SalesTaxInvoice"),
              },
              {
                name: "FetchData",
                bg: "blueDefault",
                icon: "fas fa-sync-alt",
                link: {
                  name: "salesVATItem",
                  at: RouterAction.FetchData,
                  stid: TransactionTableViewStatusType.All,
                },
                lock: { value: isLock && !this.isPackageTrial, text: "Package_Basic" },
                canNotAccess: !this.$can("create", "Create_SalesTaxInvoice"),
              },
              {
                name: "Table_Tap_AwaitFiling",
                link: { name: "salesVATItem", stid: TransactionTableViewStatusType.AwaitFiling },
                canNotAccess: !this.$can("access", "View_SalesTaxInvoice"),
              },
              {
                name: "Table_Tap_FiledTax",
                link: { name: "salesVATItem", stid: TransactionTableViewStatusType.FiledTax },
                canNotAccess: !this.$can("access", "View_SalesTaxInvoice"),
              },
              {
                name: "Menu_Overview",
                link: { name: "salesVATItem", stid: TransactionTableViewStatusType.All },
                canNotAccess: !this.$can("access", "View_SalesTaxInvoice"),
              },
            ],
          },
          {
            name: "Purchase_Tax_Item",
            link: { name: "purchaseVATItem", stid: TransactionTableViewStatusType.All },
            canNotAccess: !this.$can("access", "View_PurchaseTaxInvoice"),
            option: [
              {
                name: "Create_Purchase_Tax_Item",
                bg: "bgOption",
                link: { name: "purchaseVATItem", stid: TransactionTableViewStatusType.All, at: RouterAction.Create },
                canNotAccess: !this.$can("create", "Create_PurchaseTaxInvoice"),
              },
              {
                name: "FetchData",
                bg: "blueDefault",
                icon: "fas fa-sync-alt",
                link: {
                  name: "purchaseVATItem",
                  at: RouterAction.FetchData,
                  stid: TransactionTableViewStatusType.All,
                },
                lock: { value: isLock && !this.isPackageTrial, text: "Package_Basic" },
                canNotAccess: !this.$can("create", "Create_PurchaseTaxInvoice"),
              },
              {
                name: "Table_Tap_AwaitFiling",
                link: { name: "purchaseVATItem", stid: TransactionTableViewStatusType.AwaitFiling },
                canNotAccess: !this.$can("access", "View_PurchaseTaxInvoice"),
              },
              {
                name: "Table_Tap_FiledTax",
                link: { name: "purchaseVATItem", stid: TransactionTableViewStatusType.FiledTax },
                canNotAccess: !this.$can("access", "View_PurchaseTaxInvoice"),
              },
              {
                name: "Menu_Overview",
                link: { name: "purchaseVATItem", stid: TransactionTableViewStatusType.All },
                canNotAccess: !this.$can("access", "View_PurchaseTaxInvoice"),
              },
            ],
          },
          {
            name: "PP30_No_Form",
            link: { name: "pp30form", stid: PP30FormTableViewStatusType.All },
            canNotAccess: !this.$can("access", "View_PP30"),
            option: [
              {
                name: "Home_Create_PP30_Form",
                bg: "bgOption",
                link: { name: "pp30Create", date: new Date() },
                canNotAccess: !this.$can("create", "Create_PP30"),
              },
              {
                name: "Menu_Overview",
                link: { name: "pp30form", stid: PP30FormTableViewStatusType.All },
                canNotAccess: !this.$can("access", "View_PP30"),
              },
            ],
          },
          {
            name: "Import_Document",
            link: { name: "" },
            lock: { value: true, text: "Lock_HeaderMenu" },
            hide: true,
          },
        ],
      },
      {
        name: "Menu_Foreign_Tax",
        icon: "",
        img: require("@/assets/img/menubar/foreigner.png"),
        link: { name: "foreigner" },
        lock: { value: true, text: "Lock_HeaderMenu" },
      },
      {
        name: "Contact",
        icon: "",
        img: require("@/assets/img/menubar/user.png"),
        link: { name: "contact" },
        canNotAccess: !this.$can("access", "Contact_Menu"),
        dropdown: [
          {
            name: "Menu_Overview",
            link: { name: "contact" },
          },
          {
            name: "Add_New_Contact",
            bg: "bgSelect",
            link: { name: "contact", at: RouterAction.Create },
            canNotAccess: !this.$can("create", "Add_Contact"),
          },
        ],
      },
      {
        name: "Menu_Setting",
        icon: "",
        img: require("@/assets/img/menubar/setting.png"),
        link: { name: "settingMerchant" },
        class: "menu-margin",
        canNotAccess: !this.$can("access", "Advance_Setting") && !this.$can("access", "User_Setting_Menu"),
        dropdown: [
          {
            name: "Menu_OrganizationSetting",
            class: `optionLeft`,
            link: { name: "settingMerchant" },
            canNotAccess: !this.$can("access", "Advance_Setting"),
            option: [
              {
                name: "Organization_Setting",
                link: { name: "settingMerchant" },
                canNotAccess: !this.$can("access", "Advance_Setting"),
              },
              {
                name: "Logo_And_Stamp",
                link: { name: "settingLogoStamp" },
                canNotAccess: !this.$can("access", "Advance_Setting"),
              },
            ],
          },
          {
            name: "Connect_With_PEAK",
            class: `optionLeft`,
            link: { name: "settingConnectPeak" },
            canNotAccess: !this.$can("access", "Advance_Setting"),
            option: [
              {
                name: "Connect_With_PEAK",
                link: { name: "settingConnectPeak" },
                canNotAccess: !this.$can("access", "Advance_Setting"),
              },
              {
                name: "Header_AutoFetchData",
                link: { name: "settingAutoFetchData" },
                canNotAccess: !this.$can("access", "Advance_Setting"),
              },
            ],
          },
          {
            name: "Menu_UserSetting",
            link: { name: "settingUser" },
            canNotAccess: !this.$can("access", "User_Setting_Menu"),
          },
        ],
      },
    ];
    return listMenu;
  }

  public checkActiveMenu(linkName: any) {
    if (linkName && this.$route.matched.length > 0) {
      if (linkName.name == this.$route.matched[0].name) {
        return true;
      } else {
        return false;
      }
    }
  }

  public SetQueryURL(option: any) {
    const query: any = {
      emi: MerchantId().PeakEncryption(),
      reload: ParamsReloadType.Reload,
    };

    if (option.link && option.link.stid) {
      query.stid = option.link.stid;
    }

    if (option.link && option.link.at) {
      query.at = option.link.at;
    }
    if (option.link && option.link.epti) {
      query.epti = option.link.epti.PeakEncryption();
    }
    if (option.link && option.link.date) {
      const dateTimeNow = new Date();
      const dateTime = new Date(dateTimeNow.getFullYear(), dateTimeNow.getMonth() - 1, 1).ToDateJsonString();
      query.date = dateTime;
    }

    return query;
  }
  public hide() {
    this.hideDropdown = true;
    setTimeout(() => {
      this.hideDropdown = false;
    }, 500);
  }
}
</script>

<style lang="scss" scoped>
#mainNavbar {
  .mainNavBar {
    margin-top: 10px;
    background: white;
    border-radius: 6px;
    @include shadowboxLv2;
    .imgNewFeature {
      width: 30px;
      position: absolute;
      margin-top: -6px;
      margin-left: 2px;
    }
  }
  .mainNavBar {
    ul {
      list-style-type: none;
      margin: 0;
      padding: 0;
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      li {
        text-align: center;
        width: 100%;
        cursor: pointer;
        transition: all 0.5s ease;
        a {
          text-align: center;
          @include p2;
          color: #515278;
          div {
            padding: 25px 0px;
            span {
              padding-right: 5px;
              color: $purple_default;
            }
          }
        }
        &:hover {
          background: #e8e8e8;
          .dropdown {
            visibility: visible;
            opacity: 1;
            transition-delay: 0.3s;
          }
        }
      }
      .active {
        background: #e8e8e8;
      }
      .lockMenu {
        > div:first-child {
          position: relative;
          padding: 25px 0px;
          span {
            padding-right: 5px;
            color: $purple_default;
          }
        }
        .lockIsMenu {
          position: absolute;
          background: rgba(255, 255, 255, 0.85);
          top: 0;
          bottom: 0;
          right: 0;
          left: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          > div {
            display: none;
            color: white;
          }
          i,
          p {
            color: white;
          }
          &:hover {
            background: rgba(26, 26, 26, 0.85);
            > div {
              display: unset;
            }
          }
        }
      }
      &:first-child {
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
      }
      &:last-child {
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;
      }
    }
  }

  .dropdown {
    position: absolute;
    z-index: 99999;
    min-width: 270px;
    margin-top: -10px;
    background: white;
    border-radius: 6px;
    @include shadowboxLv2;
    visibility: hidden;
    opacity: 0;
    transition:
      visibility 0s linear 0.3s,
      opacity 0.3s linear;
    hr {
      width: 90%;
      margin: 0px auto 10px auto;
    }
    .head {
      padding: 15px 0px;
    }
    div[name="selectDropdown"] {
      &:hover {
        .option {
          visibility: visible;
          opacity: 1;
          transition-delay: 0s;
        }
        .selectDropdown {
          background: $gray_hover;
          .nameSelect,
          i {
            color: $purple_default;
          }
        }
      }
      &:first-child {
        .selectDropdown {
          border-top-left-radius: 6px;
          border-top-right-radius: 6px;
        }
      }
      &:last-child {
        .selectDropdown {
          border-bottom-left-radius: 6px;
          border-bottom-right-radius: 6px;
        }
      }
    }
    .selectDropdown {
      text-align: left;
      padding: 12px 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      > div {
        padding: 0px 0px;
        i {
          font-size: 18px;
          margin-right: 10px;
          color: $purple_default;
        }
      }
      a {
        @include font("lig");
      }
      i {
        font-size: 10px;
        color: $text;
      }
      &:hover {
        background: $gray_hover;
        .nameSelect,
        i {
          color: $purple_default;
        }
      }
    }
    .lockOrCanNotAccessSelectDropdown {
      > div:first-child {
        position: relative;
      }
      .lockOrCanNotAccessSelect {
        position: absolute;
        background: rgba(255, 255, 255, 0.85);
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
        align-items: center;
        padding: 16px;
        i,
        p {
          display: none;
          color: white !important;
        }
        &:hover {
          background: rgba(26, 26, 26, 0.85);
          i,
          p {
            display: unset;
          }
        }
      }
    }
    .option {
      background-color: white;
      position: absolute;
      right: -169px;
      margin-top: -48px;
      border-radius: 6px;
      min-width: 170px;
      border: 0px solid #e8e8e8;
      z-index: 0;
      @include shadowboxLv2;
      visibility: hidden;
      opacity: 0;
      overflow: hidden;
      transition:
        visibility 0s linear 0.3s,
        opacity 0.3s linear;
      .optionDropdown {
        padding: 12px 15px;
        a {
          @include font("lig");
        }
        i {
          margin-right: 4px;
        }
        &:hover {
          background: $gray_hover;
          a {
            color: $purple_default;
          }
        }
      }
      .bgOption {
        background: $purple_default !important;
        a {
          color: white !important;
        }
        &:hover {
          background: $purple_hover !important;
          a {
            color: white !important;
          }
        }
      }
      .blueDefault {
        a,
        i {
          color: $blue_default !important;
        }
        &:hover {
          a,
          i {
            color: $blue_default !important;
          }
        }
      }
    }

    .lockOrCanNotAccessOptionDropdown {
      > div:first-child {
        position: relative;
      }
      .lockOrCanNotAccessOption {
        position: absolute;
        background: rgba(255, 255, 255, 0.85);
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        padding: 16px 0px;
        i,
        p {
          display: none;
          color: white !important;
          margin: 5px;
        }
        &:hover {
          background: rgba(26, 26, 26, 0.85);
          i,
          p {
            display: unset;
          }
        }
      }
    }

    .optionLeft {
      right: 259px;
      min-width: 240px;
    }
    .bgSelect {
      background: $purple_default !important;
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;
      a {
        color: white !important;
      }
      &:hover {
        background: $purple_hover !important;
        a {
          color: white !important;
        }
      }
    }
  }
}
.menu-margin {
  margin-left: -50px;
  @media only screen and (max-width: 1552px) {
    margin-left: -48px;
  }
  @media only screen and (max-width: 1280px) {
    margin-left: -63px;
  }
}
.lassMenu-margin {
  margin-left: -50px;
  @media only screen and (max-width: 1824px) {
    right: 0;
    margin-right: 10px;
  }
}
</style>
